import { render } from "./PublicGallery.vue?vue&type=template&id=3ff7be00&scoped=true"
import script from "./PublicGallery.vue?vue&type=script&lang=js"
export * from "./PublicGallery.vue?vue&type=script&lang=js"

import "./PublicGallery.vue?vue&type=style&index=0&id=3ff7be00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff7be00"]])

export default __exports__